import { Platform } from 'react-native';
import { getAndUpdateDvid } from 'MMT-UI/helpers/client/dvid/index.js';
import { getNativeUserDetails } from './CommonUtils';
import { HDFC_SMART_BUY_DNS } from './RailsConstant';
import { getMmtAuth } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';

const MMT_COOKIE_KEY = 'com.makemytrip.com.rails.cookies';
const MMT_COOKIE_KEY_ARRAY = 'com.makemytrip.com.rails.cookies.arrays';


export const getCookieKeyBy = () => {
  try {
  const cookiesParsed = decodeURIComponent(document.cookie);
  const cookieArray = cookiesParsed.split(';').filter(cook => cook);
  const prevCookieArray = JSON.parse(window?.sessionStorage?.getItem(MMT_COOKIE_KEY_ARRAY) || '[]');

  if (prevCookieArray.length === cookieArray.length && cookieArray.length >= 1) {
    const prevCookieKeyBy = JSON.parse(window?.sessionStorage?.getItem(MMT_COOKIE_KEY) || '{}');
    return prevCookieKeyBy;
  }

  const cookieKeyBy = cookieArray.reduce((acc, v) => {
    const keyValArray = v.split('=');
    const key = keyValArray[0].trim();
    if (key) {
      //@ts-ignore
      acc[key] = keyValArray.slice(1).join('');
    }
    return acc;
  }, {});

  if (window.sessionStorage) {
    window.sessionStorage.setItem(MMT_COOKIE_KEY, JSON.stringify(cookieKeyBy));
    window.sessionStorage.setItem(MMT_COOKIE_KEY_ARRAY, JSON.stringify(cookieArray));
  }
  return cookieKeyBy;
  } catch (error) {
    return null;
  }
};

export const getMWebHeaders = async () => {
  let headers: any = {
    'os': Platform.OS || null,
  }
  const userInfo = await getNativeUserDetails();
  let mmtUUID = userInfo?.uuid || null;
  const cookieKeyBy = getCookieKeyBy();
  const showHdfcSmartBuy = window.location.href.toLowerCase().includes(HDFC_SMART_BUY_DNS);
  if(cookieKeyBy != null) {
    headers = {
      ...headers,
      'device-id': getAndUpdateDvid(),
      'Profile-Type': userInfo?.profileType || null,
      'uuid': mmtUUID || cookieKeyBy['mmt-uuid'],
      'mmt-uuid': mmtUUID || cookieKeyBy['mmt-uuid'],
      ...(showHdfcSmartBuy ? { affiliate: 'HDFC_SB' } : {}),
    };
    const mmtAuth = await getMmtAuth() || null;
    if (mmtAuth) {
      headers['mmt-auth'] = mmtAuth;
    }
  }
  return headers;
};
